export default __webpack_public_path__ + "static/media/covid-tracker-mockup.99d1645a.png";